import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface IBannerProps {
  /** The visual appearance of the banner */
  appearance?: 'caution' | 'danger';
  /** Additional CSS class name */
  className?: string;
  /** The content to be displayed inside the banner */
  children?: ReactNode;
  /** Custom data-cy attribute for testing */
  dataCy?: string;
}

const Layout = styled.div<Partial<IBannerProps>>`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  min-height: ${toRem(theme.button.height.small)};
  padding: ${toRem(11)} ${toRem(theme.layout.gutter.small)};
  background-color: #fee5ad;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.medium};
  font-size: ${toRem(11)};
  line-height: 100%;
  text-align: center;
  color: ${theme.color.neutral[900]};

  @media (min-width: ${theme.breakpoint.small}px) {
    min-height: ${toRem(theme.button.height.large)};
    padding: ${toRem(5.5)} ${toRem(theme.layout.gutter.small)};
    font-size: ${toRem(13.25)};
  }

  ${({ appearance }) =>
    appearance === 'danger' &&
    css`
      background-color: ${theme.color.danger.medium};
      color: ${theme.color.danger.light};
    `}
`;

const Banner = ({ appearance = 'caution', className, children, dataCy = 'banner', ...rest }: IBannerProps) => (
  <Layout appearance={appearance} className={className} data-cy={dataCy} {...rest}>
    {children}
  </Layout>
);

export default Banner;
